<template>
  <div
    v-if="dirtyDataCollectionSummary && dirtyDataCollectionSummary"
    :class="$style.container"
  >
    <div
      v-for="(collectionItem, collectionItemIndex) in configurationData"
      :key="collectionItemIndex"
      class="data-collection-summary-row-container"
    >
      <div class="each-row">
        <div
          class="columns first-row-elements"
          :class="[
            collectionItemIndex !== 0
              ? $style.applyMargin
              : $style.applyPaddingTop,
          ]"
        >
          <div class="column index-column">{{ collectionItemIndex + 1 }}.</div>
          <CriteriaViewUpdateComponent :criteria="collectionItem.criteria" />
          <div
            class="column is-1 plus-icon-column"
            v-if="collectionItem.status === 'Active'"
          >
            <a
              @click="handleCriteriaEnterData(collectionItem.id)"
              v-if="editable && isDataCollectionActive && !disabledSubmitRecord"
            >
              <img
                src="~@/assets/icons/ic_submitrecord.png"
                :class="$style.plusIcon"
              />
            </a>
          </div>
        </div>
        <div class="columns second-row-table">
          <div class="column empty-column-options"></div>
          <div class="column table-column">
            <div class="row-table-heading">
              <div class="col-answer-choices">Answer Choices</div>
              <div class="col-responses">Total To-Date</div>
            </div>
            <div
              :class="[
                Object.entries(
                  collectionItem.criteriaSamplingData
                    .criteriaOptionsDataDistribution,
                ).length > 8 &&
                (collectionItem.criteria.criteriaType === 'RANGE' ||
                  collectionItem.criteria.criteriaType ===
                    'CONTINUOUS_DISCRETE')
                  ? $style.scrollableColumn
                  : $style.nonScrollableColumn,
              ]"
            >
              <div
                class="row-table-options"
                v-for="(totalCollected, optionValue) in collectionItem
                  .criteriaSamplingData.criteriaOptionsDataDistribution"
                :key="optionValue"
              >
                <div class="option-element">
                  {{ optionValue }}
                </div>

                <div class="option-element-count">
                  {{ totalCollected }}
                </div>
              </div>
            </div>
            <div class="row-table-total">
              <div class="col-total-collected">Total Collected</div>
              <div class="col-total-collected-count">
                {{ collectionItem.criteriaSamplingData.total }}
              </div>
            </div>

            <div
              class="row-sampling-container"
              v-if="!isAuditSamplingTypeAdHoc"
            >
              <div
                v-if="collectionItem.siteSamplingDataConfigurations.length > 0"
                class="multi-site"
              >
                <div class="sampling-heading">Sampling</div>
                <div
                  v-if="
                    dataCollectionSummary.samplingConfiguration
                      .auditSamplingType === 'targetSampleSize' ||
                    (dataCollectionSummary.samplingConfiguration
                      .auditSamplingType === 'consecutive' &&
                      dataCollectionSummary.samplingConfiguration
                        .samplingMode === 'targetSample')
                  "
                  class="target-table"
                >
                  <div class="row-header columns">
                    <div class="column is-3 col-site">Site</div>
                    <div class="column col-target">Target</div>
                  </div>
                  <div class="row-data columns">
                    <div class="column is-3 col-site">All Sites</div>
                    <div class="column col-target">
                      {{
                        collectionItem.criteriaSamplingDataConfigurations
                          .sampleSize
                          ? Math.round(
                              collectionItem.criteriaSamplingDataConfigurations
                                .sampleSize,
                            )
                          : collectionItem.criteriaSamplingDataConfigurations
                              .sampleSize
                      }}
                    </div>
                  </div>
                  <div
                    class="row-data columns"
                    v-for="(
                      tempSite, tempIndex
                    ) in collectionItem.siteSamplingDataConfigurations"
                    :key="tempIndex"
                  >
                    <div class="column is-3 col-site">
                      {{ tempSite.auditSiteMap.site.name }}
                    </div>
                    <div class="column col-target">
                      {{
                        tempSite.sampleSize
                          ? Math.round(tempSite.sampleSize)
                          : tempSite.sampleSize
                      }}
                    </div>
                  </div>
                </div>
                <div v-else class="min-max-table">
                  <div class="row-header columns">
                    <div class="column is-3 col-site">Site</div>
                    <div class="column col-min">Min.</div>
                    <div class="column col-max">Max.</div>
                  </div>
                  <div class="row-data columns">
                    <div class="column is-3 col-site">All Sites</div>
                    <div class="column col-min">
                      {{
                        collectionItem.criteriaSamplingDataConfigurations
                          .minSampleSize
                          ? Math.round(
                              collectionItem.criteriaSamplingDataConfigurations
                                .minSampleSize,
                            )
                          : collectionItem.criteriaSamplingDataConfigurations
                              .minSampleSize
                      }}
                    </div>
                    <div class="column col-max">
                      {{
                        collectionItem.criteriaSamplingDataConfigurations
                          .maxSampleSize
                          ? Math.round(
                              collectionItem.criteriaSamplingDataConfigurations
                                .maxSampleSize,
                            )
                          : collectionItem.criteriaSamplingDataConfigurations
                              .maxSampleSize
                      }}
                    </div>
                  </div>
                  <div
                    class="row-data columns"
                    v-for="(
                      tempSite, tempIndex
                    ) in collectionItem.siteSamplingDataConfigurations"
                    :key="tempIndex"
                  >
                    <div class="column is-3 col-site">
                      {{ tempSite.auditSiteMap.site.name }}
                    </div>
                    <div class="column col-min">
                      {{
                        tempSite.minSampleSize
                          ? Math.round(tempSite.minSampleSize)
                          : tempSite.minSampleSize
                      }}
                    </div>
                    <div class="column col-max">
                      {{
                        tempSite.maxSampleSize
                          ? Math.round(tempSite.maxSampleSize)
                          : tempSite.maxSampleSize
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="single-site">
                <div v-if="collectionItem.criteriaSamplingDataConfigurations">
                  <div
                    class="type-target-sample-size"
                    v-if="
                      dataCollectionSummary.samplingConfiguration
                        .auditSamplingType === 'targetSampleSize' ||
                      (dataCollectionSummary.samplingConfiguration
                        .auditSamplingType === 'consecutive' &&
                        dataCollectionSummary.samplingConfiguration
                          .samplingMode === 'targetSample')
                    "
                  >
                    <div class="target-title">Target</div>
                    <div class="target-count">
                      {{
                        collectionItem.criteriaSamplingDataConfigurations
                          .sampleSize
                          ? Math.round(
                              collectionItem.criteriaSamplingDataConfigurations
                                .sampleSize,
                            )
                          : collectionItem.criteriaSamplingDataConfigurations
                              .sampleSize
                      }}
                    </div>
                  </div>
                  <div
                    class="type-consecutive-min"
                    v-if="
                      dataCollectionSummary.samplingConfiguration
                        .auditSamplingType === 'consecutive' &&
                      dataCollectionSummary.samplingConfiguration
                        .samplingMode === 'minAndMax' &&
                      collectionItem.criteriaSamplingDataConfigurations
                        .minSampleSize !== null
                    "
                  >
                    <div class="min-title">Min</div>
                    <div class="min-count">
                      {{
                        collectionItem.criteriaSamplingDataConfigurations
                          .minSampleSize
                          ? Math.round(
                              collectionItem.criteriaSamplingDataConfigurations
                                .minSampleSize,
                            )
                          : collectionItem.criteriaSamplingDataConfigurations
                              .minSampleSize
                      }}
                    </div>
                  </div>
                  <div
                    class="type-consecutive-max"
                    v-if="
                      dataCollectionSummary.samplingConfiguration
                        .auditSamplingType === 'consecutive' &&
                      dataCollectionSummary.samplingConfiguration
                        .samplingMode === 'minAndMax' &&
                      collectionItem.criteriaSamplingDataConfigurations
                        .maxSampleSize !== null
                    "
                  >
                    <div class="max-title">Max</div>
                    <div class="max-count">
                      {{
                        collectionItem.criteriaSamplingDataConfigurations
                          .maxSampleSize
                          ? Math.round(
                              collectionItem.criteriaSamplingDataConfigurations
                                .maxSampleSize,
                            )
                          : collectionItem.criteriaSamplingDataConfigurations
                              .maxSampleSize
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-1 empty-column-options"></div>
        </div>
        <hr
          class="divider"
          v-if="
            collectionItemIndex + 1 !==
            dataCollectionSummary.configurationData.length
          "
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  DataCollectionSummaryRequestPayload,
  DataCollectionSummaryResponsePayload,
} from '@/store/modules/audits/types/audits.types';
import { Action, State } from 'vuex-class';
import { cloneDeep as _cloneDeep, orderBy as _orderBy } from 'lodash';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import CriteriaViewUpdateComponent from '../../Project/components/CriteriaViewUpdateComponent.vue';
@Component({
  components: {
    CriteriaViewUpdateComponent,
  },
})
export default class DataCollectionSummaryTab extends Vue {
  @Prop()
  public selectedSites!: number[];
  @Prop()
  public auditId!: number;
  @Prop({ default: true })
  public editable!: boolean;
  @Prop({ default: false })
  public isDataCollectionActive!: boolean;
  @Prop({ default: false })
  public disabledSubmitRecord!: boolean;

  public dirtyDataCollectionSummary: any = {};

  @Action('audits/getDataCollectionSummary')
  public getDataCollectionSummary!: (
    payload: DataCollectionSummaryRequestPayload,
  ) => void;

  @State((state) => state.audits.dataCollectionSummary)
  public dataCollectionSummary!: DataCollectionSummaryResponsePayload;

  public mounted() {
    this.getDataCollectionSummary({
      auditId: this.auditId,
    });
  }

  @Watch('dataCollectionSummary')
  public watchDataCollectionSummary() {
    this.dirtyDataCollectionSummary = _cloneDeep(this.dataCollectionSummary);
  }

  @Watch('selectedSites')
  @isTruthy
  public watchSelectedSites(newValue: number[]) {
    if (newValue.length > 0) {
      this.getDataCollectionSummary({
        auditId: this.auditId,
        siteIds: newValue.join(),
      });
    } else {
      this.dirtyDataCollectionSummary.configurationData.forEach(
        (summary: any) => {
          summary.criteriaSamplingData.total = 0;
          for (const key of Object.keys(
            summary.criteriaSamplingData.criteriaOptionsDataDistribution,
          )) {
            summary.criteriaSamplingData.criteriaOptionsDataDistribution[
              key
            ] = 0;
          }
        },
      );
    }
  }

  public handleCriteriaEnterData(auditCriteriaId: number) {
    this.$router.push({
      name: 'audit',
      params: {
        auditId: this.auditId.toString(),
      },
      hash: '#submitRecord',
    });
    this.$emit('showDataCollectionTemplateForSingleCriteria', auditCriteriaId);
  }

  get configurationData() {
    return _orderBy(
      this.dirtyDataCollectionSummary.configurationData,
      ['order'],
      ['asc'],
    );
  }

  get isAuditSamplingTypeAdHoc() {
    if (this.dirtyDataCollectionSummary) {
      return this.dirtyDataCollectionSummary.samplingConfiguration
        .auditSamplingType === 'adHoc'
        ? true
        : false;
    } else {
      return false;
    }
  }
}
</script>
<style lang="scss" module>
.container {
  margin-top: 13px;
  margin-left: 23px;
  padding: 0;
  background-color: white;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
}

.plusIcon {
  color: #21b5ea;
  width: 16px;
  height: 16px;
}
.applyMargin {
  margin-top: 0px;
}
.applyPaddingTop {
  padding-top: 8px;
}
.applyPaddingBottom {
  padding-bottom: 8px;
}
.scrollableColumn {
  overflow-y: scroll;
  height: 220px;
}
.nonScrollableColumn {
  height: auto;
}
</style>
